import * as angular from 'angular';

import { IDispatcherService, IDispatcher, IOnlineUserActionsService, } from '../';
import { OnlineUserDto } from '../../models';

export interface IOnlineUsersStoreService {
    getAll: () => angular.IPromise<OnlineUserDto[]>;
    updateOne: (user: OnlineUserDto, isRemove: boolean) => angular.IPromise<OnlineUserDto[]>;
}

export interface IOnlineUsersActionDispatcherService extends IDispatcherService<IOnlineUsersStoreService> { }

export class OnlineUsersActionDispatcherService implements IOnlineUsersActionDispatcherService {
    static serviceId = 'onlineUsersActionDispatcherService';

    static $inject = ['onlineUserActionsService'];

    constructor(private _actionService: IOnlineUserActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IOnlineUsersStoreService> {
        return {
            dispatcher: {
                getAll: () => dispatch(this._actionService.getAll()),
                updateOne: (user: OnlineUserDto, isRemove: boolean) => dispatch(this._actionService.updateOne(user, isRemove))
            }
        };
    }
}